import { render, staticRenderFns } from "./ListClassification.vue?vue&type=template&id=d8fa6d5c&scoped=true&lang=pug&"
import script from "./ListClassification.vue?vue&type=script&lang=js&"
export * from "./ListClassification.vue?vue&type=script&lang=js&"
import style0 from "./ListClassification.vue?vue&type=style&index=0&id=d8fa6d5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8fa6d5c",
  null
  
)

export default component.exports